import React from 'react'
import { InputAdornment, TextField } from '@material-ui/core'

import { Dai, WhiteTooltip } from 'components'

import useStyles from './styles'

const TextFieldComponent = ({
  hiddenDaiIcon = false,
  tooltipProps,
  ...props
}) => {
  const classes = useStyles()

  return (
    <TextField
      {...(!hiddenDaiIcon && {
        InputProps: {
          startAdornment: (
            <WhiteTooltip aiAlert cursor="help" {...tooltipProps}>
              <InputAdornment position="start" className={classes.adornment}>
                <Dai.StarIcon size={14} />
              </InputAdornment>
            </WhiteTooltip>
          ),
        },
      })}
      {...props}
    />
  )
}

export default TextFieldComponent
